import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

const userTestimonials = [
  {
    name: 'Jaiden',
    occupation: 'President and Head of Software',
    testimonial:
      "I am excited to work with new members to lead them on a personalized path to meet their personal goals and objectives as President. As head of Software, I aim above all to teach new members to teach themselves and use their resources to become specialized experts.",
  },
  {
    name: 'Kaden',
    occupation: 'Vice-President and Head of Engineering',
    testimonial:
      "As Head of Engineering, I want new members walking away from build season knowing how to turn an idea into a working part, not just how to follow instructions. We'll spend plenty of time in CAD and at the 3D printers, but the real goal is building the confidence to prototype, test, and iterate on your own designs. I'm hopeful this incoming class enjoys the process as much as I have and pushes the team's engineering even further.",
  },
  {
    name: 'Mia',
    occupation: 'Secretary and Head of Outreach',
    testimonial:
      "As Secretary and Head of Outreach, I'm looking forward to helping new members find their place on the team, whether that's on the build floor or out in the community representing us at events. There's a role here for everyone, no matter your background.",
  }
];

export default function Testimonials() {
  return (
    <Container
      id="testimonials"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: { sm: 'left', md: 'center' },
        }}
      >
        <Typography
          component="h2"
          variant="h4"
          gutterBottom
          sx={{ color: 'text.primary' }}
        >
          Message from Leadership
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          Club Leadership is looking forward to working with new members.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {userTestimonials.map((testimonial, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index} sx={{ display: 'flex' }}>
            <Card
              variant="outlined"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flexGrow: 1,
              }}
            >
              <CardContent>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ color: 'text.secondary' }}
                >
                  {testimonial.testimonial}
                </Typography>
              </CardContent>
              <CardHeader
                title={testimonial.name}
                subheader={testimonial.occupation}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
